import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';
import { FC } from 'react';
import { TutorialState } from '../handlers/TutorialHandler';
import { ThemeHandler } from '../handlers/ThemeHandler';
import { TourProvider } from '@reactour/tour';
import { TilesHandler } from '../handlers/TilesHandler';
import Layout from './Layout';

import '../index.css';
import { TilesInterface } from './Grid/tiles';
import { TranslationHandler } from '../handlers/TranslationsHandler';
import { SiteHandler } from '../handlers/SiteHandler';

interface CockpitConfiguratorProps {
  isInSpecialMode: boolean;
  isInFinancesMode: boolean;
  onTilesChange?: (tiles: TilesInterface[]) => void;
  onThemeChange?: (theme: string) => void;
  onLogoChange?: (logo: string | ArrayBuffer | null) => void;
}

export const CockpitConfigurator: FC<CockpitConfiguratorProps> = ({
  isInSpecialMode = false,
  isInFinancesMode = false,
  onTilesChange,
  onLogoChange,
  onThemeChange
}) => {
  const instance = createInstance({
    urlBase: 'https://matomo.urbanpulse.de/',
    siteId: 'wPpDny5J42vK3xjNz1mL' as any,
    configurations: {
      disableCookies: true
    }
  });

  return (
    <MatomoProvider value={instance}>
      <TranslationHandler>
        <SiteHandler>
          <TutorialState>
            <ThemeHandler
              setLogoCallback={onLogoChange}
              setThemeCallback={onThemeChange}
            >
              <TourProvider
                steps={[]}
                showBadge={false}
                showNavigation={false}
                showCloseButton={false}
                disableInteraction={true}
                onClickMask={({ setIsOpen }) => setIsOpen(true)}
                styles={{
                  popover: base => ({
                    ...base,
                    padding: 0
                  })
                }}
                padding={{
                  mask: 0
                }}
              >
                <TilesHandler
                  isInSpecialMode={isInSpecialMode}
                  setGlobalTiles={onTilesChange}
                  isInFinancesMode={isInFinancesMode}
                >
                  <Layout />
                </TilesHandler>
              </TourProvider>
            </ThemeHandler>
          </TutorialState>
        </SiteHandler>
      </TranslationHandler>
    </MatomoProvider>
  );
};
